import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { saveToken } from "../lib/api";
import { toast } from "sonner";
import "../components/AppLayout.css";
import "./AuthPage.css";

export default function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [pendingMsg, setPendingMsg] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPendingMsg("");
    try {
      const { data } = await api.post("/auth/login", { identifier, password });
      saveToken(data.token);
      localStorage.setItem("cos_user", JSON.stringify(data.user));
      toast.success(`Welcome ${data.user.name}`);
      navigate("/");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (err?.response?.status === 403 && typeof detail === "string" && detail.includes("pending")) {
        setPendingMsg(detail);
      } else {
        toast.error(typeof detail === "string" ? detail : "Login failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sms-shell">
      <header className="sms-banner">
        <div className="sms-banner-inner">
          <div className="sms-brand">
            <img src="/crest.svg" alt="" className="sms-brand-crest" width="56" height="50" />
            <span className="sms-brand-text">UK Visas &amp; Immigration</span>
          </div>
        </div>
      </header>
      <nav className="sms-breadcrumb" aria-label="breadcrumb">
        <div className="sms-breadcrumb-inner">
          <span className="sms-crumb-lead">You are here</span>
          <span className="sms-crumb"><span className="sms-crumb-sep">&gt;</span><span>Sponsorship management system</span></span>
          <span className="sms-crumb"><span className="sms-crumb-sep">&gt;</span><span>Sign in</span></span>
        </div>
      </nav>

      <div className="sms-auth-wrap">
        <div className="sms-auth-panel">
          <h1>Sign in</h1>
          <p className="sms-auth-lead">
            Enter your username or email and password to access the Sponsorship
            management system.
          </p>

          {pendingMsg && (
            <div data-testid="pending-notice" className="sms-auth-alert warning">
              {pendingMsg}
            </div>
          )}

          <form onSubmit={submit} data-testid="login-form" className="sms-auth-form">
            <div className="sms-auth-field">
              <label htmlFor="identifier">Username or email</label>
              <input
                id="identifier"
                data-testid="login-identifier"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                autoComplete="username"
                className="sms-input"
                required
              />
            </div>
            <div className="sms-auth-field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className="sms-input"
                required
              />
            </div>

            <div className="sms-auth-actions">
              <button
                type="submit"
                data-testid="login-submit"
                disabled={loading}
                className="sms-btn"
              >
                {loading ? "Signing in…" : "Sign in"}
              </button>
              <Link to="/signup" data-testid="link-to-signup" className="sms-auth-link">
                Request access
              </Link>
            </div>
          </form>
        </div>
        <p className="sms-auth-note">
          Access is restricted to approved users. New sign-ups require an
          administrator to review the request before access is granted.
        </p>
      </div>
    </div>
  );
}
